export { default as ConsoleVersionBanner } from './ConsoleVersionBanner';
